import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import type {SvgIconProps} from '@mui/material/SvgIcon/SvgIcon';

export default function OutlookCalendar(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.0002 3.3335C12.6408 3.3335 9.41894 4.66802 7.04348 7.04348C4.66802 9.41894 3.3335 12.6408 3.3335 16.0002C3.3335 19.3596 4.66802 22.5814 7.04348 24.9568C9.41894 27.3323 12.6408 28.6668 16.0002 28.6668C19.3596 28.6668 22.5814 27.3323 24.9568 24.9568C27.3323 22.5814 28.6668 19.3596 28.6668 16.0002C28.6668 12.6408 27.3323 9.41894 24.9568 7.04348C22.5814 4.66802 19.3596 3.3335 16.0002 3.3335Z" fill="#039BE5" />
                <path d="M17.7145 19.3575H20.9925L21.5072 16.0275H17.7139V14.2075C17.7139 12.8242 18.1659 11.5975 19.4599 11.5975H21.5392V8.69151C21.1739 8.64218 20.4012 8.53418 18.9412 8.53418C15.8925 8.53418 14.1052 10.1442 14.1052 13.8122V16.0275H10.9712V19.3575H14.1052V28.5102C14.7259 28.6035 15.3545 28.6668 15.9999 28.6668C16.5832 28.6668 17.1525 28.6135 17.7145 28.5375V19.3575Z" fill="white" />
            </svg>
        </SvgIcon>
    );
}
